import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { Post } from 'Xhr/Xhr';
import Cookies from 'js-cookie';

export const HandleAddSuggestion = (
  data,
  element,
  networkErrorMsg,
  setForceRender,
  processingRequestMsg
) => {
  const IdPerson =
    Cookies.get('user') &&
    JSON.parse(Cookies.get('user'))?.IdPerson;
  console.log('title data =>', {
    Name: data.title,
    Description: data.description,
    IdElsRecord: Number(element.ElsRecord.Id),
    IdPerson,
  });

  SwalAlert('warning', processingRequestMsg, false);

  Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_ELSFORMPATIENT_ADD_ELSRECORD_DEFAULT_ANSWER}`,
    true,
    {
      Name: data.title,
      Description: data.description,
      IdElsRecord: Number(element.ElsRecord.Id),
      IdPerson,
    }
  )
    .then((response) => {
      if (response.data.resCode !== 1) {
        SwalAlert('error', networkErrorMsg, false);
      } else {
        SwalAlert(
          'success',
          response.data.resMessage,
          false
        );
      }
    })
    .then(() => {
      setForceRender((prev) => !prev);
    });
};
